export function featuresSliderHolder() {
    const $window = $(window);
    const $sliderHolder = $(".features-slider-holder");
    const $sliderThumbnails = $sliderHolder.find(".features-slider-nav");
    const $sliderContent = $sliderHolder.find(".features-slider-content");
    let $sliderThumbnailsLength = $sliderContent.find(".item").length;
    let $sliderTab = $sliderThumbnails.find(".item");
    let timeOutId;
    let timeOutIdHover;
    $sliderContent.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: false,
        asNavFor: $sliderThumbnails,
        autoplay: true,
        autoplaySpeed: 4900,
        pauseOnHover: false,
        adaptiveHeight: true,
        prevArrow: "<button class=\"slide-arrow slick-prev\"><svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n" +
            "<path d=\"M5.76256 9.95006L6.38128 9.33134L2.48645 5.43651L12.751 5.43651L12.751 4.56412L2.48645 4.56412L6.38128 0.669287L5.76256 0.0505685L0.812815 5.00032L5.76256 9.95006Z\" fill=\"#111111\"/>\n" +
            "</svg></button>",
        nextArrow: "<button class=\"slide-arrow slick-next\"><svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n" +
            "<path d=\"M7.23744 9.95006L6.61872 9.33134L10.5136 5.43651L0.249013 5.43651L0.249013 4.56412L10.5136 4.56412L6.61872 0.669287L7.23744 0.0505685L12.1872 5.00032L7.23744 9.95006Z\" fill=\"#111111\"/>\n" +
            "</svg></button>",
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 300,
                settings: {
                    arrows: true
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    arrows: false
                }
            }, {
                breakpoint: 1200,
                settings: {
                    adaptiveHeight: false
                }
            }
        ]
    });
    $sliderThumbnails.slick({
        slidesToShow: 1.1,
        slidesToScroll: 1,
        asNavFor: $sliderContent,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        mobileFirst: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 6100,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 1023,
                settings: {
                    slidesToShow: $sliderThumbnailsLength,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $sliderContent.on("afterChange", function (event, slick, currentSlide) {
        videoOnSlide();
        if (currentSlide === $sliderThumbnailsLength - 1) {
            timeOutId = setTimeout(function () {
                $sliderContent.slick("slickGoTo", 0);
                $sliderContent.slick('refresh');
                $sliderThumbnails.slick("slickGoTo", 0);
                $sliderThumbnails.slick('refresh');
            }, 4899);
        }
    });
    $sliderContent.on("beforeChange", function (event, slick, currentSlide) {
        if (currentSlide === $sliderThumbnailsLength - 1) {
            $sliderThumbnails.find(".item").removeClass("paused");
            clearTimeout(timeOutId);
        }
    });

    function videoOnSlide() {
        let curren = $sliderContent.find(".slick-current");
        if (curren.find("video").length) {
            curren.find("video")[0].play();
        }
    }

    videoOnSlide();

    $window.on("resize", function () {
        let $slidesShown = $sliderThumbnails.slick("slickGetOption", "slidesToShow");
        if ($sliderThumbnailsLength <= $slidesShown) {
            setTimeout(() => {
                $sliderThumbnails.find(".slick-track").css("transform", "translate3d(0px, 0px, 0px)");
            }, 500);
        }
    });

    function pauseSlider() {
        $sliderContent.slick("slickPause");
        $sliderThumbnails.find(".slick-current .item").addClass("paused");
        clearTimeout(timeOutId);
        clearTimeout(timeOutIdHover);
    }

    function resumeSlider() {
        $sliderContent.slick("slickPlay");
        $sliderThumbnails.find(".slick-current .item").removeClass("paused");
        timeOutIdHover = setTimeout(function () {
            if ($sliderThumbnails.find(".slick-current").index() === $sliderThumbnailsLength - 1) {
                $sliderContent.slick("slickGoTo", 0);
                $sliderContent.slick('refresh');
                $sliderThumbnails.slick("slickGoTo", 0);
                $sliderThumbnails.slick('refresh');
            }
        }, 4899);
    }

    if ($window.width() > 1199) {
        $sliderThumbnails.hover(function () {
            pauseSlider();
        }, function () {
            resumeSlider();
        });
    }
    if ($window.width() < 1200) {
        $sliderContent.on("touchstart", function (e) {
            $sliderContent.slick("slickPause");
            $sliderThumbnails.find(".slick-current .item").addClass("paused");
            $(this).one("touchend", function (e) {
                $(this).off("touchmove");
                $sliderContent.slick("slickPlay");
                $sliderThumbnails.find(".item").removeClass("paused");
            });
        });
    }

    $window.on("load scroll", function () {
        let $winTop = $window.scrollTop();
        let $windowBottomPosition = ($winTop + $window.height());
        $sliderThumbnails.each(function () {
            let $this = $(this);
            let $sectionTop = $this.offset().top;
            if ($windowBottomPosition > $sectionTop) {
                $this.addClass("show");
                $sliderContent.slick("slickPlay");
                $this.find(".slick-current").addClass("active");
                $this.find($sliderTab).removeClass("paused");
            } else {
                $this.removeClass("show");
                $sliderContent.slick("slickPause");
                $this.find(".slick-current .item").addClass("paused");
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuresSliderHolder.js